export class Gallery {
    ID:number;
CLIENT_ID:number;
GROUP_ID:number;
NAME:string;
IMAGE_URL:string;
SEQUENCE_NO:number;
STATUS:boolean=true;

}